import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=a7944b22&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=a7944b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7944b22",
  null
  
)

export default component.exports